/**
 * Created by cl-macmini-51 on 04/07/18.
 */

import { WalletStatus } from '../enums/enum';

export class ModalType {
  static get LARGE() { return 'modal-lg'; }
  static get MEDIUM() { return 'modal-md'; }
  static get SMALL() { return 'modal-sm'; }
}

export const country = {
  countries: [
    {
      name: '',
      dialCode: '93',
      countryCode: 'af'
    },
    {
      name: '',
      dialCode: '355',
      countryCode: 'al'
    },
    {
      name: '',
      dialCode: '213',
      countryCode: 'dz'
    },
    {
      name: '',
      dialCode: '1684',
      countryCode: 'as'
    },
    {
      name: '',
      dialCode: '376',
      countryCode: 'ad'
    },
    {
      name: '',
      dialCode: '244',
      countryCode: 'ao'
    },
    {
      name: '',
      dialCode: '1264',
      countryCode: 'ai'
    },
    {
      name: '',
      dialCode: '1268',
      countryCode: 'ag'
    },
    {
      name: '',
      dialCode: '54',
      countryCode: 'ar'
    },
    {
      name: '',
      dialCode: '374',
      countryCode: 'am'
    },
    {
      name: '',
      dialCode: '297',
      countryCode: 'aw'
    },
    {
      name: '',
      dialCode: '61',
      countryCode: 'au'
    },
    {
      name: '',
      dialCode: '43',
      countryCode: 'at'
    },
    {
      name: '',
      dialCode: '994',
      countryCode: 'az'
    },
    {
      name: '',
      dialCode: '1242',
      countryCode: 'bs'
    },
    {
      name: '',
      dialCode: '973',
      countryCode: 'bh'
    },
    {
      name: '',
      dialCode: '880',
      countryCode: 'bd'
    },
    {
      name: '',
      dialCode: '1246',
      countryCode: 'bb'
    },
    {
      name: '',
      dialCode: '375',
      countryCode: 'by'
    },
    {
      name: '',
      dialCode: '32',
      countryCode: 'be'
    },
    {
      name: '',
      dialCode: '501',
      countryCode: 'bz'
    },
    {
      name: '',
      dialCode: '229',
      countryCode: 'bj'
    },
    {
      name: '',
      dialCode: '1441',
      countryCode: 'bm'
    },
    {
      name: '',
      dialCode: '975',
      countryCode: 'bt'
    },
    {
      name: '',
      dialCode: '591',
      countryCode: 'bo'
    },
    {
      name: '',
      dialCode: '387',
      countryCode: 'ba'
    },
    {
      name: '',
      dialCode: '267',
      countryCode: 'bw'
    },
    {
      name: '',
      dialCode: '55',
      countryCode: 'br'
    },
    {
      name: '',
      dialCode: '246',
      countryCode: 'io'
    },
    {
      name: '',
      dialCode: '1284',
      countryCode: 'vg'
    },
    {
      name: '',
      dialCode: '673',
      countryCode: 'bn'
    },
    {
      name: '',
      dialCode: '359',
      countryCode: 'bg'
    },
    {
      name: '',
      dialCode: '226',
      countryCode: 'bf'
    },
    {
      name: '',
      dialCode: '257',
      countryCode: 'bi'
    },
    {
      name: '',
      dialCode: '855',
      countryCode: 'kh'
    },
    {
      name: '',
      dialCode: '237',
      countryCode: 'cm'
    },
    {
      name: '',
      dialCode: '1',
      countryCode: 'ca'
    },
    {
      name: '',
      dialCode: '238',
      countryCode: 'cv'
    },
    {
      name: '',
      dialCode: '599',
      countryCode: 'bq'
    },
    {
      name: '',
      dialCode: '1345',
      countryCode: 'ky'
    },
    {
      name: '',
      dialCode: '236',
      countryCode: 'cf'
    },
    {
      name: '',
      dialCode: '235',
      countryCode: 'td'
    },
    {
      name: '',
      dialCode: '56',
      countryCode: 'cl'
    },
    {
      name: '',
      dialCode: '86',
      countryCode: 'cn'
    },
    {
      name: '',
      dialCode: '61',
      countryCode: 'cx'
    },
    {
      name: '',
      dialCode: '61',
      countryCode: 'cc'
    },
    {
      name: '',
      dialCode: '57',
      countryCode: 'co'
    },
    {
      name: '',
      dialCode: '269',
      countryCode: 'km'
    },
    {
      name: '',
      dialCode: '243',
      countryCode: 'cd'
    },
    {
      name: '',
      dialCode: '242',
      countryCode: 'cg'
    },
    {
      name: '',
      dialCode: '682',
      countryCode: 'ck'
    },
    {
      name: '',
      dialCode: '506',
      countryCode: 'cr'
    },
    {
      name: '',
      dialCode: '225',
      countryCode: 'ci'
    },
    {
      name: '',
      dialCode: '385',
      countryCode: 'hr'
    },
    {
      name: '',
      dialCode: '53',
      countryCode: 'cu'
    },
    {
      name: '',
      dialCode: '599',
      countryCode: 'cw'
    },
    {
      name: '',
      dialCode: '357',
      countryCode: 'cy'
    },
    {
      name: '',
      dialCode: '420',
      countryCode: 'cz'
    },
    {
      name: '',
      dialCode: '45',
      countryCode: 'dk'
    },
    {
      name: '',
      dialCode: '253',
      countryCode: 'dj'
    },
    {
      name: '',
      dialCode: '1767',
      countryCode: 'dm'
    },
    {
      name: '',
      dialCode: '1',
      countryCode: 'do'
    },
    {
      name: '',
      dialCode: '593',
      countryCode: 'ec'
    },
    {
      name: '',
      dialCode: '20',
      countryCode: 'eg'
    },
    {
      name: '',
      dialCode: '503',
      countryCode: 'sv'
    },
    {
      name: '',
      dialCode: '240',
      countryCode: 'gq'
    },
    {
      name: '',
      dialCode: '291',
      countryCode: 'er'
    },
    {
      name: '',
      dialCode: '372',
      countryCode: 'ee'
    },
    {
      name: '',
      dialCode: '251',
      countryCode: 'et'
    },
    {
      name: '',
      dialCode: '500',
      countryCode: 'fk'
    },
    {
      name: '',
      dialCode: '298',
      countryCode: 'fo'
    },
    {
      name: '',
      dialCode: '679',
      countryCode: 'fj'
    },
    {
      name: '',
      dialCode: '358',
      countryCode: 'fi'
    },
    {
      name: '',
      dialCode: '33',
      countryCode: 'fr'
    },
    {
      name: '',
      dialCode: '594',
      countryCode: 'gf'
    },
    {
      name: '',
      dialCode: '689',
      countryCode: 'pf'
    },
    {
      name: '',
      dialCode: '241',
      countryCode: 'ga'
    },
    {
      name: '',
      dialCode: '220',
      countryCode: 'gm'
    },
    {
      name: '',
      dialCode: '995',
      countryCode: 'ge'
    },
    {
      name: '',
      dialCode: '49',
      countryCode: 'de'
    },
    {
      name: '',
      dialCode: '233',
      countryCode: 'gh'
    },
    {
      name: '',
      dialCode: '350',
      countryCode: 'gi'
    },
    {
      name: '',
      dialCode: '30',
      countryCode: 'gr'
    },
    {
      name: '',
      dialCode: '299',
      countryCode: 'gl'
    },
    {
      name: '',
      dialCode: '1473',
      countryCode: 'gd'
    },
    {
      name: '',
      dialCode: '590',
      countryCode: 'gp'
    },
    {
      name: '',
      dialCode: '1671',
      countryCode: 'gu'
    },
    {
      name: '',
      dialCode: '502',
      countryCode: 'gt'
    },
    {
      name: '',
      dialCode: '44',
      countryCode: 'gg'
    },
    {
      name: '',
      dialCode: '224',
      countryCode: 'gn'
    },
    {
      name: '',
      dialCode: '245',
      countryCode: 'gw'
    },
    {
      name: '',
      dialCode: '592',
      countryCode: 'gy'
    },
    {
      name: '',
      dialCode: '509',
      countryCode: 'ht'
    },
    {
      name: '',
      dialCode: '504',
      countryCode: 'hn'
    },
    {
      name: '',
      dialCode: '852',
      countryCode: 'hk'
    },
    {
      name: '',
      dialCode: '36',
      countryCode: 'hu'
    },
    {
      name: '',
      dialCode: '354',
      countryCode: 'is'
    },
    {
      name: '',
      dialCode: '91',
      countryCode: 'in'
    },
    {
      name: '',
      dialCode: '62',
      countryCode: 'id'
    },
    {
      name: '',
      dialCode: '98',
      countryCode: 'ir'
    },
    {
      name: '',
      dialCode: '964',
      countryCode: 'iq'
    },
    {
      name: '',
      dialCode: '353',
      countryCode: 'ie'
    },
    {
      name: '',
      dialCode: '44',
      countryCode: 'im'
    },
    {
      name: '',
      dialCode: '972',
      countryCode: 'il'
    },
    {
      name: '',
      dialCode: '39',
      countryCode: 'it'
    },
    {
      name: '',
      dialCode: '1876',
      countryCode: 'jm'
    },
    {
      name: '',
      dialCode: '1658',
      countryCode: 'jm'
    },
    {
      name: '',
      dialCode: '81',
      countryCode: 'jp'
    },
    {
      name: '',
      dialCode: '44',
      countryCode: 'je'
    },
    {
      name: '',
      dialCode: '962',
      countryCode: 'jo'
    },
    {
      name: '',
      dialCode: '7',
      countryCode: 'kz'
    },
    {
      name: '',
      dialCode: '254',
      countryCode: 'ke'
    },
    {
      name: '',
      dialCode: '686',
      countryCode: 'ki'
    },
    {
      name: '',
      dialCode: '383',
      countryCode: 'xk'
    },
    {
      name: '',
      dialCode: '965',
      countryCode: 'kw'
    },
    {
      name: '',
      dialCode: '996',
      countryCode: 'kg'
    },
    {
      name: '',
      dialCode: '856',
      countryCode: 'la'
    },
    {
      name: '',
      dialCode: '371',
      countryCode: 'lv'
    },
    {
      name: '',
      dialCode: '961',
      countryCode: 'lb'
    },
    {
      name: '',
      dialCode: '266',
      countryCode: 'ls'
    },
    {
      name: '',
      dialCode: '231',
      countryCode: 'lr'
    },
    {
      name: '',
      dialCode: '218',
      countryCode: 'ly'
    },
    {
      name: '',
      dialCode: '423',
      countryCode: 'li'
    },
    {
      name: '',
      dialCode: '370',
      countryCode: 'lt'
    },
    {
      name: '',
      dialCode: '352',
      countryCode: 'lu'
    },
    {
      name: '',
      dialCode: '853',
      countryCode: 'mo'
    },
    {
      name: '',
      dialCode: '389',
      countryCode: 'mk'
    },
    {
      name: '',
      dialCode: '261',
      countryCode: 'mg'
    },
    {
      name: '',
      dialCode: '265',
      countryCode: 'mw'
    },
    {
      name: '',
      dialCode: '60',
      countryCode: 'my'
    },
    {
      name: '',
      dialCode: '960',
      countryCode: 'mv'
    },
    {
      name: '',
      dialCode: '223',
      countryCode: 'ml'
    },
    {
      name: '',
      dialCode: '356',
      countryCode: 'mt'
    },
    {
      name: '',
      dialCode: '692',
      countryCode: 'mh'
    },
    {
      name: '',
      dialCode: '596',
      countryCode: 'mq'
    },
    {
      name: '',
      dialCode: '222',
      countryCode: 'mr'
    },
    {
      name: '',
      dialCode: '230',
      countryCode: 'mu'
    },
    {
      name: '',
      dialCode: '262',
      countryCode: 'yt'
    },
    {
      name: '',
      dialCode: '52',
      countryCode: 'mx'
    },
    {
      name: '',
      dialCode: '691',
      countryCode: 'fm'
    },
    {
      name: '',
      dialCode: '373',
      countryCode: 'md'
    },
    {
      name: '',
      dialCode: '377',
      countryCode: 'mc'
    },
    {
      name: '',
      dialCode: '976',
      countryCode: 'mn'
    },
    {
      name: '',
      dialCode: '382',
      countryCode: 'me'
    },
    {
      name: '',
      dialCode: '1664',
      countryCode: 'ms'
    },
    {
      name: '',
      dialCode: '212',
      countryCode: 'ma'
    },
    {
      name: '',
      dialCode: '258',
      countryCode: 'mz'
    },
    {
      name: '',
      dialCode: '95',
      countryCode: 'mm'
    },
    {
      name: '',
      dialCode: '264',
      countryCode: 'na'
    },
    {
      name: '',
      dialCode: '674',
      countryCode: 'nr'
    },
    {
      name: '',
      dialCode: '977',
      countryCode: 'np'
    },
    {
      name: '',
      dialCode: '31',
      countryCode: 'nl'
    },
    {
      name: '',
      dialCode: '687',
      countryCode: 'nc'
    },
    {
      name: '',
      dialCode: '64',
      countryCode: 'nz'
    },
    {
      name: '',
      dialCode: '505',
      countryCode: 'ni'
    },
    {
      name: '',
      dialCode: '227',
      countryCode: 'ne'
    },
    {
      name: '',
      dialCode: '234',
      countryCode: 'ng'
    },
    {
      name: '',
      dialCode: '683',
      countryCode: 'nu'
    },
    {
      name: '',
      dialCode: '672',
      countryCode: 'nf'
    },
    {
      name: '',
      dialCode: '850',
      countryCode: 'kp'
    },
    {
      name: '',
      dialCode: '1670',
      countryCode: 'mp'
    },
    {
      name: '',
      dialCode: '47',
      countryCode: 'no'
    },
    {
      name: '',
      dialCode: '968',
      countryCode: 'om'
    },
    {
      name: '',
      dialCode: '92',
      countryCode: 'pk'
    },
    {
      name: '',
      dialCode: '680',
      countryCode: 'pw'
    },
    {
      name: '',
      dialCode: '970',
      countryCode: 'ps'
    },
    {
      name: '',
      dialCode: '507',
      countryCode: 'pa'
    },
    {
      name: '',
      dialCode: '675',
      countryCode: 'pg'
    },
    {
      name: '',
      dialCode: '595',
      countryCode: 'py'
    },
    {
      name: '',
      dialCode: '51',
      countryCode: 'pe'
    },
    {
      name: '',
      dialCode: '63',
      countryCode: 'ph'
    },
    {
      name: '',
      dialCode: '48',
      countryCode: 'pl'
    },
    {
      name: '',
      dialCode: '351',
      countryCode: 'pt'
    },
    {
      name: '',
      dialCode: '1',
      countryCode: 'pr'
    },
    {
      name: '',
      dialCode: '974',
      countryCode: 'qa'
    },
    {
      name: '',
      dialCode: '262',
      countryCode: 're'
    },
    {
      name: '',
      dialCode: '40',
      countryCode: 'ro'
    },
    {
      name: '',
      dialCode: '7',
      countryCode: 'ru'
    },
    {
      name: '',
      dialCode: '250',
      countryCode: 'rw'
    },
    {
      name: '',
      dialCode: '590',
      countryCode: 'bl'
    },
    {
      name: '',
      dialCode: '290',
      countryCode: 'sh'
    },
    {
      name: '',
      dialCode: '1869',
      countryCode: 'kn'
    },
    {
      name: '',
      dialCode: '1758',
      countryCode: 'lc'
    },
    {
      name: '',
      dialCode: '590',
      countryCode: 'mf'
    },
    {
      name: '',
      dialCode: '508',
      countryCode: 'pm'
    },
    {
      name: '',
      dialCode: '1784',
      countryCode: 'vc'
    },
    {
      name: '',
      dialCode: '685',
      countryCode: 'ws'
    },
    {
      name: '',
      dialCode: '378',
      countryCode: 'sm'
    },
    {
      name: '',
      dialCode: '239',
      countryCode: 'st'
    },
    {
      name: '',
      dialCode: '966',
      countryCode: 'sa'
    },
    {
      name: '',
      dialCode: '221',
      countryCode: 'sn'
    },
    {
      name: '',
      dialCode: '381',
      countryCode: 'rs'
    },
    {
      name: '',
      dialCode: '248',
      countryCode: 'sc'
    },
    {
      name: '',
      dialCode: '232',
      countryCode: 'sl'
    },
    {
      name: '',
      dialCode: '65',
      countryCode: 'sg'
    },
    {
      name: '',
      dialCode: '1721',
      countryCode: 'sx'
    },
    {
      name: '',
      dialCode: '421',
      countryCode: 'sk'
    },
    {
      name: '',
      dialCode: '386',
      countryCode: 'si'
    },
    {
      name: '',
      dialCode: '677',
      countryCode: 'sb'
    },
    {
      name: '',
      dialCode: '252',
      countryCode: 'so'
    },
    {
      name: '',
      dialCode: '27',
      countryCode: 'za'
    },
    {
      name: '',
      dialCode: '82',
      countryCode: 'kr'
    },
    {
      name: '',
      dialCode: '211',
      countryCode: 'ss'
    },
    {
      name: '',
      dialCode: '34',
      countryCode: 'es'
    },
    {
      name: '',
      dialCode: '94',
      countryCode: 'lk'
    },
    {
      name: '',
      dialCode: '249',
      countryCode: 'sd'
    },
    {
      name: '',
      dialCode: '597',
      countryCode: 'sr'
    },
    {
      name: '',
      dialCode: '47',
      countryCode: 'sj'
    },
    {
      name: '',
      dialCode: '268',
      countryCode: 'sz'
    },
    {
      name: '',
      dialCode: '46',
      countryCode: 'se'
    },
    {
      name: '',
      dialCode: '41',
      countryCode: 'ch'
    },
    {
      name: '',
      dialCode: '963',
      countryCode: 'sy'
    },
    {
      name: '',
      dialCode: '886',
      countryCode: 'tw'
    },
    {
      name: '',
      dialCode: '992',
      countryCode: 'tj'
    },
    {
      name: '',
      dialCode: '255',
      countryCode: 'tz'
    },
    {
      name: '',
      dialCode: '66',
      countryCode: 'th'
    },
    {
      name: '',
      dialCode: '670',
      countryCode: 'tl'
    },
    {
      name: '',
      dialCode: '228',
      countryCode: 'tg'
    },
    {
      name: '',
      dialCode: '690',
      countryCode: 'tk'
    },
    {
      name: '',
      dialCode: '676',
      countryCode: 'to'
    },
    {
      name: '',
      dialCode: '1868',
      countryCode: 'tt'
    },
    {
      name: '',
      dialCode: '216',
      countryCode: 'tn'
    },
    {
      name: '',
      dialCode: '90',
      countryCode: 'tr'
    },
    {
      name: '',
      dialCode: '993',
      countryCode: 'tm'
    },
    {
      name: '',
      dialCode: '1649',
      countryCode: 'tc'
    },
    {
      name: '',
      dialCode: '688',
      countryCode: 'tv'
    },
    {
      name: '',
      dialCode: '1340',
      countryCode: 'vi'
    },
    {
      name: '',
      dialCode: '256',
      countryCode: 'ug'
    },
    {
      name: '',
      dialCode: '380',
      countryCode: 'ua'
    },
    {
      name: '',
      dialCode: '971',
      countryCode: 'ae'
    },
    {
      name: '',
      dialCode: '44',
      countryCode: 'gb'
    },
    {
      name: '',
      dialCode: '1',
      countryCode: 'us'
    },
    {
      name: '',
      dialCode: '598',
      countryCode: 'uy'
    },
    {
      name: '',
      dialCode: '998',
      countryCode: 'uz'
    },
    {
      name: '',
      dialCode: '678',
      countryCode: 'vu'
    },
    {
      name: '',
      dialCode: '39',
      countryCode: 'va'
    },
    {
      name: '',
      dialCode: '58',
      countryCode: 've'
    },
    {
      name: '',
      dialCode: '84',
      countryCode: 'vn'
    },
    {
      name: '',
      dialCode: '681',
      countryCode: 'wf'
    },
    // {
    //   name: '',
    //   dialCode: '212',
    //   countryCode: 'eh'
    // },
    {
      name: '',
      dialCode: '967',
      countryCode: 'ye'
    },
    {
      name: '',
      dialCode: '260',
      countryCode: 'zm'
    },
    {
      name: '',
      dialCode: '263',
      countryCode: 'zw'
    },
    {
      name: '',
      dialCode: '358',
      countryCode: 'ax'
    }
  ]
};


export const TaskStatus = {
  0: { status: "ASSIGNED", color: '#f5a946' },
  1: { status: "STARTED", color: '#4695f5' },
  2: { status: "SUCCESSFUL", color: '#66d02a' },
  3: { status: "FAILED", color: '#e2574c' },
  4: { status: "INPROGRESS", color: '#166bd3' },
  5: { status: "PARTIAL", color: '#e2574c' },
  6: { status: "UNASSIGNED", color: 'darkblue' },
  7: { status: "ACCEPTED", color: '#ba68c8' },
  8: { status: "DECLINED", color: '#cb3529' },
  9: { status: "CANCELED", color: '#bfbfbf' },
  10: { status: "DELETED", color: '#cb3529' },
  11: { status: "IGNORED", color: 'orange' },
  12: { status: "SEEN BY AGENT", color: '#3e2723' },
  13: { status: "PARTIALLY FAILED", color: '#cb3529' },
  14: { status: "PARTIALLY CANCELLED", color: '#cb3529' },
  15: { status: "PARTIALLY COMPLETED", color: '#827717' },
  16: { status: "ASSIGNING", color: '#00695c' },
  17: { status: "SCHEDULED", color: '#880e4f' },
  18: { status: "ARRIVED", color: '#166bd3' },
  19: { status: "UNFULFILLED", color: '#cb3529' },
  20: { status: "START END", color: '#00838f ' },
}

export enum DynamicTemplateDataType {
  DROPDOWN = "Dropdown",
  TEXT = "Text",
  NUMBER = "Number",
  IMAGE = "Image",
  CHECKBOX = "Checkbox",
  EMAIL = "Email",
  TELEPHONE = "Telephone",
  SINGLE_SELECT = "Single-Select",
  SINGLE_SELECT_DELIVERY_TEMPLATE= 'Single-Select-Delivery-Template',
  MULTI_SELECT = "Multi-Select",
  TEXTAREA = "TextArea",
  DATE = "Date",
  DATE_FUTURE = "Date-Future",
  DATE_PAST = "Date-Past",
  DATE_TIME = "Date-Time",
  DATE_TIME_FUTURE = "Datetime-Future",
  DATE_TIME_PAST = "Datetime-Past",
  TIME = "Time",
  DOCUMENT = 'Document',
  URL = 'URL'
};

export const COUNTRY_NAME = {
  'ax': 'AALAND ISLANDS',
  'af': 'AFGHANISTAN',
  'al': 'ALBANIA',
  'dz': 'ALGERIA',
  'as': 'AMERICAN SAMOA',
  'ad': 'ANDORRA',
  'ao': 'ANGOLA',
  'ai': 'ANGUILLA',
  'aq': 'ANTARCTICA',
  'ag': 'ANTIGUA AND BARBUDA',
  'ar': 'ARGENTINA',
  'am': 'ARMENIA',
  'aw': 'ARUBA',
  'au': 'AUSTRALIA',
  'at': 'AUSTRIA',
  'az': 'AZERBAIJAN',
  'bs': 'BAHAMAS',
  'bh': 'BAHRAIN',
  'bd': 'BANGLADESH',
  'bb': 'BARBADOS',
  'by': 'BELARUS',
  'be': 'BELGIUM',
  'bz': 'BELIZE',
  'bj': 'BENIN',
  'bm': 'BERMUDA',
  'bt': 'BHUTAN',
  'bo': 'BOLIVIA',
  'ba': 'BOSNIA AND HERZEGOWINA',
  'bw': 'BOTSWANA',
  'bv': 'BOUVET ISLAND',
  'br': 'BRAZIL',
  'io': 'BRITISH INDIAN OCEAN TERRITORY',
  'bn': 'BRUNEI DARUSSALAM',
  'bg': 'BULGARIA',
  'bf': 'BURKINA FASO',
  'bi': 'BURUNDI',
  'bq': 'CARIBBEAN NETHERLANDS',
  'kh': 'CAMBODIA',
  'cm': 'CAMEROON',
  'ca': 'CANADA',
  'cv': 'CAPE VERDE',
  'ky': 'CAYMAN ISLANDS',
  'cf': 'CENTRAL AFRICAN REPUBLIC',
  'td': 'CHAD',
  'cl': 'CHILE',
  'cn': 'CHINA',
  'cx': 'CHRISTMAS ISLAND',
  'cc': 'COCOS ISLANDS',
  'co': 'COLOMBIA',
  'km': 'COMOROS',
  'cd': 'CONGO',
  'cg': 'CONGO REPUBLIC',
  'ck': 'COOK ISLANDS',
  'cr': 'COSTA RICA',
  'ci': 'COTE DIVOIRE',
  'hr': 'CROATIA ',
  'cu': 'CUBA',
  'cw': 'CURACAO',
  'cy': 'CYPRUS',
  'cz': 'CZECH REPUBLIC',
  'dk': 'DENMARK',
  'dj': 'DJIBOUTI',
  'dm': 'DOMINICA',
  'do': 'DOMINICAN REPUBLIC',
  'ec': 'ECUADOR',
  'eg': 'EGYPT',
  'sv': 'EL SALVADOR',
  'gq': 'EQUATORIAL GUINEA',
  'er': 'ERITREA',
  'ee': 'ESTONIA',
  'et': 'ETHIOPIA',
  'fk': 'FALKLAND ISLANDS (MALVINAS)',
  'fo': 'FAROE ISLANDS',
  'fj': 'FIJI',
  'fi': 'FINLAND',
  'fr': 'FRANCE',
  'gf': 'FRENCH GUIANA',
  'pf': 'FRENCH POLYNESIA',
  'tf': 'FRENCH SOUTHERN TERRITORIES',
  'ga': 'GABON',
  'gm': 'GAMBIA',
  'ge': 'GEORGIA',
  'de': 'GERMANY',
  'gh': 'GHANA',
  'gi': 'GIBRALTAR',
  'gr': 'GREECE',
  'gl': 'GREENLAND',
  'gd': 'GRENADA',
  'gp': 'GUADELOUPE',
  'gu': 'GUAM',
  'gt': 'GUATEMALA',
  'gg': 'GUERNSEY',
  'gn': 'GUINEA',
  'gw': 'GUINEA-BISSAU',
  'gy': 'GUYANA',
  'ht': 'HAITI',
  'hm': 'HEARD AND MC DONALD ISLANDS',
  'hn': 'HONDURAS',
  'hk': 'HONG KONG',
  'hu': 'HUNGARY',
  'is': 'ICELAND',
  'in': 'INDIA',
  'id': 'INDONESIA',
  'ir': 'IRAN ',
  'iq': 'IRAQ',
  'ie': 'IRELAND',
  'im': 'ISLA DE MAN',
  'il': 'ISRAEL',
  'it': 'ITALY',
  'jm': 'JAMAICA',
  'jp': 'JAPAN',
  'je': 'JERSEY',
  'jo': 'JORDAN',
  'kz': 'KAZAKHSTAN',
  'ke': 'KENYA',
  'ki': 'KIRIBATI',
  'kp': 'KOREA NORTH ',
  'kr': 'KOREA SOUTH',
  'xk': 'KOSOVO',
  'kw': 'KUWAIT',
  'kg': 'KYRGYZSTAN',
  'la': 'LAO',
  'lv': 'LATVIA',
  'lb': 'LEBANON',
  'ls': 'LESOTHO',
  'lr': 'LIBERIA',
  'ly': 'LIBYAN ARAB JAMAHIRIYA',
  'li': 'LIECHTENSTEIN',
  'lt': 'LITHUANIA',
  'lu': 'LUXEMBOURG',
  'mo': 'MACAU',
  'mk': 'MACEDONIA',
  'mg': 'MADAGASCAR',
  'mw': 'MALAWI',
  'my': 'MALAYSIA',
  'mv': 'MALDIVES',
  'ml': 'MALI',
  'mt': 'MALTA',
  'mh': 'MARSHALL ISLANDS',
  'mq': 'MARTINIQUE',
  'mr': 'MAURITANIA',
  'mu': 'MAURITIUS',
  'yt': 'MAYOTTE',
  'mx': 'MEXICO',
  'fm': 'MICRONESIA',
  'md': 'MOLDOVA',
  'mc': 'MONACO',
  'mn': 'MONGOLIA',
  'me': 'MONTENEGRO',
  'ms': 'MONTSERRAT',
  'ma': 'MOROCCO',
  'mz': 'MOZAMBIQUE',
  'mm': 'MYANMAR',
  'na': 'NAMIBIA',
  'nr': 'NAURU',
  'np': 'NEPAL',
  'nl': 'NETHERLANDS',
  'an': 'NETHERLANDS ANTILLES',
  'nc': 'NEW CALEDONIA',
  'nz': 'NEW ZEALAND',
  'ni': 'NICARAGUA',
  'ne': 'NIGER',
  'ng': 'NIGERIA',
  'nu': 'NIUE',
  'nf': 'NORFOLK ISLAND',
  'mp': 'NORTHERN MARIANA ISLANDS',
  'no': 'NORWAY',
  'om': 'OMAN',
  'pk': 'PAKISTAN',
  'pw': 'PALAU',
  'ps': 'PALESTINA',
  'pa': 'PANAMA',
  'pg': 'PAPUA NEW GUINEA',
  'py': 'PARAGUAY',
  'pe': 'PERU',
  'ph': 'PHILIPPINES',
  'pn': 'PITCAIRN',
  'pl': 'POLAND',
  'pt': 'PORTUGAL',
  'pr': 'PUERTO RICO',
  'qa': 'QATAR',
  're': 'REUNION',
  'ro': 'ROMANIA',
  'ru': 'RUSSIAN FEDERATION',
  'rw': 'RWANDA',
  'sh': 'SAINT HELENA',
  'kn': 'SAINT KITTS AND NEVIS',
  'lc': 'SAINT LUCIA',
  'pm': 'SAINT PIERRE AND MIQUELON',
  'vc': 'SAINT VINCENT AND THE GRENADINES',
  'ws': 'SAMOA',
  'bl': 'SAN BARTOLOMÉ',
  'sm': 'SAN MARINO',
  'st': 'SAO TOME AND PRINCIPE',
  'sa': 'SAUDI ARABIA',
  'sn': 'SENEGAL',
  'cs': 'SERBIA AND MONTENEGRO',
  'rs': 'SERBIA',
  'sc': 'SEYCHELLES',
  'sl': 'SIERRA LEONE',
  'sg': 'SINGAPORE',
  'sx': 'SINT MAARTEN',
  'sk': 'SLOVAKIA',
  'si': 'SLOVENIA',
  'sb': 'SOLOMON ISLANDS',
  'so': 'SOMALIA',
  'za': 'SOUTH AFRICA',
  'gs': 'SOUTH GEORGIA ISLANDS',
  'es': 'SPAIN',
  'lk': 'SRI LANKA',
  'sd': 'SUDAN',
  'ss': 'SOUTH SUDAN',
  'sr': 'SURINAME',
  'sj': 'SVALBARD AND JAN MAYEN ISLANDS',
  'sz': 'SWAZILAND',
  'se': 'SWEDEN',
  'ch': 'SWITZERLAND',
  'sy': 'SYRIAN ARAB REPUBLIC',
  'tw': 'TAIWAN',
  'tj': 'TAJIKISTAN',
  'tz': 'TANZANIA',
  'th': 'THAILAND',
  'tl': 'TIMOR-LESTE',
  'tg': 'TOGO',
  'tk': 'TOKELAU',
  'to': 'TONGA',
  'tt': 'TRINIDAD AND TOBAGO',
  'tn': 'TUNISIA',
  'tr': 'TURKEY',
  'tm': 'TURKMENISTAN',
  'tc': 'TURKS AND CAICOS ISLANDS',
  'tv': 'TUVALU',
  'ug': 'UGANDA',
  'ua': 'UKRAINE',
  'ae': 'UNITED ARAB EMIRATES',
  'gb': 'UNITED KINGDOM',
  'us': 'UNITED STATES',
  'um': 'UNITED STATES MINOR OUTLYING ISLANDS',
  'uy': 'URUGUAY',
  'uz': 'UZBEKISTAN',
  'vu': 'VANUATU',
  'va': 'VATICAN CITY STATE',
  've': 'VENEZUELA',
  'vn': 'VIET NAM',
  'vg': 'VIRGIN ISLANDS (BRITISH)',
  'vi': 'VIRGIN ISLANDS (U.S.)',
  'wf': 'WALLIS AND FUTUNA ISLANDS',
  // 'eh': 'WESTERN SAHARA',
  'ye': 'YEMEN',
  'zm': 'ZAMBIA',
  'zw': 'ZIMBABWE '
};
export const validations = {
  numbersWithDecimal: /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/,
  onlyNumbers: /^[0-9]*$/,
};
export const PhoneMinMaxValidation = {
  MIN_LENGTH: 6,
  MAX_LENGTH: 17
};


/** Tookan not following response code standards. */
export function tookanResponse(res: any, index: number) {
  if (!(res.status === 200)) {
    if (res.status === 101) {
      localStorage.clear();
      this.router.navigate(['/']);
      try {
        (window as any).shutDownFugu();
      } catch (error) {
        console.error(error);
      }
    }
    throw new Error(res.message);
  } else {
    return res;
  }
}


export const priceType = {
  '1': {
    'name': 'Fixed',
    'id': '1',
    'value': 1,
  },
  '2': {
    'name': 'Minute',
    'id': '2',
    'value': 2,
    'minutes': 1
  },
  '3': {
    'name': 'Hour',
    'id': '3',
    'value': 3,
    'minutes': 60,
  },
  '4': {
    'name': 'Day',
    'id': '4',
    'value': 4,
    'minutes': 1440,
  },
  '5': {
    'name': 'Week',
    'id': '5',
    'value': 5,
    'minutes': 10080,
  },
  '6': {
    'name': 'Month',
    'id': '6',
    'value': 6,
    'minutes': 43200,
  },
  '7': {
    'name': 'Year',
    'id': '7',
    'value': 7,
    'minutes': 525600,
  },
  '8': {
    'name': 'Kg',
    'id': '8',
    'value': 8,
  },
  '9': {
    'name': 'Pound',
    'id': '9',
    'value': 9,
  },
  '10': {
    'name': 'Person',
    'id': '10',
    'value': 10,
  },
  '11': {
    'name': 'Km',
    'id': '11',
    'value': 11,
  },
  '12': {
    'name': 'Feet',
    'id': '12',
    'value': 12,
  },
  '13': {
    'name': 'Sqft',
    'id': '13',
    'value': 13,
  },
  '14': {
    'name': 'LFT',
    'id': '14',
    'value': 14,
  },
  '15': {
    'name': 'Sqm',
    'id': '15',
    'value': 15,
  },
  '16': {
    'name': 'Metre',
    'id': '16',
    'value': 16,
  },
  '17':{
    'name': 'Millilitre',
    'id': '17',
    'value': 17,
  },
  '18': {
    'name': 'Litre',
    'id': '18',
    'value': 18,
  },
  '19': {
    'name': 'Acre',
    'id': '19',
    'value': 19,
  },
  '20': {
    'name': 'Gallon',
    'id': '20',
    'value': 20,
  }
};

export const TransactionStatus = {
  1: {
    action: 'ORDER_COMPlETE',
    label: 'Paid',
    color_class: 'Paid'
  },
  2: {
    action: 'TRANSACTION_COMPLETE',
    label: 'Paid',
    color_class: 'Paid'
  },
  3: {
    action: 'INIT',
    label: 'Unpaid',
    color_class: 'Unpaid'
  },
  4: {
    action: 'PAYMENT_FAILED_REFUNDED',
    label: 'Unpaid',
    color_class: 'Unpaid'
  },
  5: {
    action: 'TRANSACTION_INCOMPLETE',
    label: 'Unpaid',
    color_class: 'Unpaid'
  },
  6: {
    action: 'REFUNDED',
    label: 'Refunded',
    color_class: 'Paid'
  },
  7: {
    action: 'TRANSACTION_FAILED',
    label: 'Unpaid',
    color_class: 'Unpaid'
  },
  8: {
    action: 'PARTIAL_PAYMENT',
    label: 'Partial',
    color_class: 'Partial'
  },
  9: {
    action: 'PARTIALLY_REFUNDED',
    label: 'Partially Refunded',
    color_class:'Paid'
  },
  10: {
    action: 'PAYMENT_HOLD',
    label: 'On Hold',
    color_class:'Hold'
  },
  11: {
    action: 'PAYMENT_RELEASED',
    label: 'Payment Released',
    color_class:'Released'
  }
}

export const Routes = {
  'catalogRoute': 'app/components/catalogue/catalogue.module#CatalogueModule',
  'restaurantRoute': 'app/components/restaurants-new/restaurants.module#RestaurantsModule',
  'dyRestaurantRoute': 'app/themes-custom/modules/restaurants-new/restaurants-new.module#DynamicRestaurantsNewModule',
  'dyCatalogRoute' : 'app/themes-custom/modules/catalogue/catalogue.module#DynamicCatalogueModule',
  'staticFetchLocation' : '../app/components/fetch-location/fetch-location.module#FetchLocationModule',
  'dynamicFetchLocationModule' : 'app/themes-custom/modules/fetch-location/fetch-location.module#DynamicFetchLocationModule'
}

export const MessageType = {
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error'
}
export const WeekDays = [
  {
    "day_id": 0,
    "day_name": "Sunday",
    "is_active": false,
    "is_selected": false
  },
  {
    "day_id": 1,
    "day_name": "Monday",
    "is_active": false,
    "is_selected": false
  },
  {
    "day_id": 2,
    "day_name": "Tuesday",
    "is_active": false,
    "is_selected": false
  },
  {
    "day_id": 3,
    "day_name": "Wednesday",
    "is_active": false,
    "is_selected": false
  },
  {
    "day_id": 4,
    "day_name": "Thursday",
    "is_active": false,
    "is_selected": false
  },
  {
    "day_id": 5,
    "day_name": "Friday",
    "is_active": false,
    "is_selected": false
  },
  {
    "day_id": 6,
    "day_name": "Saturday",
    "is_active": false,
    "is_selected": false
  }
];

export const OrderType = {
  INSTANT_ORDER: 'orderNow',
  RECURRING_ORDER: 'subscription',
  SCHEDULED_ORDER: 'schedule'
}
export const filterWalletKeyEnum = [
  {
    "id": 2,
    "label": "Paid",
    "types": [WalletStatus.DEDUCTION, WalletStatus.P2P_SENT]
  },
  {
    "id": 1,
    "label": "Added",
    "types": [WalletStatus.ADD]
  },
  {
    "id": 8,
    "label": "Deducted",
    "types": [WalletStatus.ADMIN_DEDUCTION]
  },
  {
    "id": 3,
    "label": "Refunded",
    "types": [WalletStatus.REFUND]
  },
  {
    "id": 4,
    "label": "Credited",
    "types": [WalletStatus.FAIL, WalletStatus.P2P_RECEIVED]
  },
  {
    "id": 5,
    "label": "Failed",
    "types": [WalletStatus.FAIL]
  },
];

export const pCalenderLocale = {
  es:{
        firstDayOfWeek: 1,
        dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
        dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
        dayNamesMin: [ "D","L","M","X","J","V","S" ],
        monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
        monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
        today: 'Hoy',
        clear: 'Borrar'
    },
  en:{
      firstDayOfWeek: 0,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"],
      monthNames: [ "January","February","March","April","May","June","July","August","September","October","November","December" ],
      monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'mm/dd/yy',
      weekHeader: 'Wk'
  }
}


export const externalCoins= [
  {
    key : 2,
    coin_type : "Tata Neu",
  },
];

export const tataExternalLinks = {
  terms_and_condition: "https://aem-sit-r2.tatadigital.com/login/termsandconditions",
  privacy_policy: "https://aem-sit-r2.tatadigital.com/login/privacypolicy",
};

export class BillModel {
  ACTUAL_AMOUNT: number;
  BENEFIT_TYPE: any;
  CREDITS_TO_ADD: number;
  CREDITS_USED: string;
  CURRENT_CREDITS: any;
  DEFAULT_SERVICE_TAX_PERCENT: number;
  DEFAULT_VAT_PERCENT: number;
  DISCOUNT: string;
  DISCOUNTED_AMOUNT: number;
  NET_PAYABLE_AMOUNT: number;
  PAYABLE_AMOUNT: string;
  PAYABLE_AMOUNT_WITHOUT_CREDITS: number;
  SERVICE_TAX: number;
  TIP: number;
  VAT: number;
}

export enum Daytime {
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  EVENING = 'Evening'
}

export enum restrictionType  {
    NO_RESTRICTION = 0,
    SERVING_RADIUS = 1,
    GEOFENCE       = 2
};

export const ADDONS = {
  MEALME : 138,
  SHOPIFY : 144,
  EVERMILE: 145,
}

export const ITEM_AVAILABILITY_STATUS = {
    OK         : 'ok',
    FIX_NEEDED : 'fix_needed',
    UNAVAILABLE: 'unavailable',
} as const;

export const OPTION_AVAILABILITY_STATUS = {
    OK                 : 'ok',
    UNMAPPED           : 'unmapped',
    DELETED            : 'deleted',
    UNAVAILABLE        : 'unavailable',
    INSUFFICIENT_STOCK : 'insufficient_stock',
    PROVIDER_ERROR     : 'provider_error',
} as const;

export const SIGNUP_MANDATORY_FIELDS = {
  EMAIL : 0,
  PHONE : 1,
  EMAIL_AND_PHONE : 2,
}
export const PRODUCT_TEMPLATES = {
  TEMPLATE_0 : 0,
  TEMPLATE_1 : 1,
  TEMPLATE_2 : 2,
  TEMPLATE_3 : 3,
}

export const MODULE_VERSION = {
  product_description_page : 'product_description_page',
}

export const WalletToolsTabEnum = {
  WALLET_ID : 1,
  P2P : 2,
}

// Address types for the Evermile
export const ADDRESS_TYPE = { 
  RESIDENTIAL : { key: "residential_building", value: "Residential Building" },
  RESIDENTIAL_PRIVATE : { key: "residential_private", value: "Residential Private" },
  WAREHOUSE : { key: "warehouse", value: "Warehouse" },
  STORE : { key: "store", value: "Store" },
  PUDO : { key: "pudo", value: "PUDO" }, // Pick Up Drop Off Depot
  OFFICE : { key: "office", value: "Office" }
}

